<template>
  <div>
    <div class='row'>
      <div class='col s12'>
        <input type='text' @blur="$emit('update')" v-model.trim='address.name' placeholder='Full Name'>
        <div class='error' v-if='!$v.name.required'>Name is required</div>
        <div class='error' v-if='!$v.name.maxLength'>Name is too long</div>
        <div class='error' v-if='!$v.name.noSpecialCharacters'>Name must not contain special characters</div>
        <div class='error' v-if='!$v.name.noNumbers'>Name must not contain numbers</div>
        <div class='error' v-if='!$v.name.hasFirstAndLastName'>You must provide a first and last name</div>
      </div>
    </div>

    <div class='row'>
      <div class='col l8 s12'>
        <input type='text' @blur="$emit('update')" v-model.trim='address.address_1' placeholder='Address'>
        <div class='error' v-if='!$v.address_1.required'>Address is required</div>
        <div class='error' v-if='!$v.address_1.maxLength'>Address is too long (35 characters)</div>
        <div class='error' v-if='!$v.address_1.noSpecialCharacters'>Address must not contain special characters</div>
      </div>

      <div class='col l4 s12'>
        <input type='text' @blur="$emit('update')" v-model.trim='address.address_2' placeholder='Apt, suite, etc'>
        <div class='error' v-if='!$v.address_2.maxLength'>Address is too long (35 characters)</div>
        <div class='error' v-if='!$v.address_2.noSpecialCharacters'>Address must not contain special characters</div>
      </div>
    </div>

    <div class='row'>
      <div class='col s12'>
        <input type='text' @blur="$emit('update')" v-model.trim='address.city' placeholder='City'>
        <div class='error' v-if='!$v.city.required'>City is required</div>
        <div class='error' v-if='!$v.city.maxLength'>City is too long</div>
        <div class='error' v-if='!$v.city.noSpecialCharacters'>City must not contain special characters</div>
      </div>
    </div>

    <div class='row'>
      <div class='col l9 s12' style="margin-bottom: 0">
        <div class='row'>
          <div class='col l6 s12'>
            <select name='country' v-model='address.country' class='country' @change='address.state = ""'>
              <option v-for='country in countries' :key='country.name' :value='country.name'>
                {{ country.name }}
              </option>
            </select>
          </div>

          <div class='col l6 s12'>
            <select name='state' @change="$emit('update')" v-model='address.state' class='state' :disabled="states().length === 0">
              <option value='' disabled selected='selected'>Select a state</option>
              <option v-for='state in states()' :key='state' :value='state'>
                {{ state }}
              </option>
            </select>
            <div class='error' v-if='!$v.state.presence'>State is required</div>
          </div>
        </div>
      </div>

      <div class='col l3 s12'>
        <input type='text' @keydown="restrict_zipcode_input" @keyup="format_zipcode" @blur="zipcode_updated" :disabled="!postal_code()" v-model.trim='address.zipcode' placeholder='Zipcode' class='zipcode'>
        <div class='error' v-if='!$v.zipcode.presence'>Zipcode is required</div>
        <div class='error' v-if='!$v.zipcode.maxLength'>Zipcode is too long</div>
        <div class='error' v-if='!$v.zipcode.minLength'>Zipcode is too short</div>
        <div :class='{ errors: $v.zipcode.$error }'>
          <div class='error' v-if='!$v.zipcode.format'>Zipcode must be 5 or 9 digits</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import countries from 'app/countries.json';
import { is_military_address, is_us_territory } from 'app/helpers/AddressHelpers';
import find from 'lodash/find';
import includes from 'lodash/includes';

  export default {
    props: ['address', '$v'],
    data () {
      return { countries }
    },
    methods: {
      country () {
        return find(countries, (country) => {
          return country.name == this.address.country
        })
      },

      states () {
        let _country = this.country();
        if (_country) {
          return _country.states
        } else {
          return []
        }
      },

      postal_code () {
        let _country = this.country()
        if (_country) {
          return _country.postal_code
        } else {
          return null
        }
      },

      restrict_zipcode_input (event) {
        if (includes(['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Delete', 'Backspace'], event.key)) return
        if ((event.ctrlKey || event.metaKey) && event.key == 'v') return // allow paste
        if (this.address.country != 'United States of America') return
        if (is_us_territory(this.address.state)) return
        if (is_military_address(this.address.state)) return

        if (/[^\d-]/.test(event.key)) {
          event.preventDefault()
        }
      },

      format_zipcode (event) {
        if (this.address.country != 'United States of America') return
        if (is_us_territory(this.address.state)) return
        if (is_military_address(this.address.state)) return

        let zipcode = event.target.value.replace(/[^\d]/g, '')
        if (zipcode.length > 5 || zipcode.length == 5 && event.key == '-') {
          zipcode = zipcode.replace(/(\d{5})(\d*)/, '$1-$2')
        }
        this.$set(this.address, 'zipcode', zipcode)
      },

      zipcode_updated (event) {
        this.format_zipcode(event)
        this.$v.zipcode.$touch()
        this.$emit('update')
      }
    }
  }
</script>
